import { render, staticRenderFns } from "./listaAllenamenti.vue?vue&type=template&id=3c9afc09"
import script from "./listaAllenamenti.vue?vue&type=script&lang=js"
export * from "./listaAllenamenti.vue?vue&type=script&lang=js"
import style0 from "./listaAllenamenti.vue?vue&type=style&index=0&id=3c9afc09&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports